import axios from 'axios'
import { device } from './device_service';
// Importe a criptografia no topo para evitar o overhead do await em cada request
import CryptoJSAesJson from './CryptoJSAesJson'; 

const api = axios.create({
  baseURL: process.env.VUE_APP_baseURL,
  withCredentials: true
})

api.interceptors.request.use(config => {
  // 1. Pegue o token e limpe aspas e espaços imediatamente
  let token = sessionStorage.getItem('jwtToken');
  
  if (token) {
    // Remove aspas extras (caso o login salve com JSON.stringify) e espaços
    token = token.replace(/"/g, '').trim();
    
    // 2. Validação básica: se não tiver pontos, não é um JWT válido
    if (token.includes('.')) {
        config.headers.Authorization = `Bearer ${token}`;
    }
  }

  // 3. Criptografia (Removi o await para ganhar performance)
  const password = process.env.VUE_APP_CHAVE_CRIPTOGRAFIA.toString();
  
  // Envelopando em blocos try/catch para evitar que erro de criptografia quebre a request
  try {
    config.headers['CENPROT-Description'] = btoa(JSON.stringify(CryptoJSAesJson.encrypt(device.value, password)));
    config.headers['CENPROT-Plataform'] = btoa(JSON.stringify(CryptoJSAesJson.encrypt(device.isMobile, password)));
  } catch (e) {
    console.error("Erro na criptografia dos headers de segurança", e);
  }

  return config;
}, error => {
  return Promise.reject(error)
})

export default api;